import { adminApi } from './api';

/* ==========================================
    강사 관리 (Instructor Management)
========================================== */

/**
 * 강사 목록 조회 (검색 안됨, 페이징 안됨)
 */
export const fetchInstructorList = async () => {
    const response = await adminApi.get(`/api/admin/instructors`);
    return response.data.data;
};